import React from 'react'
import moment from 'moment'

import TimeRange from 'live/components/ui/time-range'
import i18n from 'live/services/i18n'

import { ViewAnnotation } from '../../styles'
import { AdvancedAnnotation } from 'plugin-annotations-templates/webapp/src/types'

interface AnnotationCardProps {
    event: AdvancedAnnotation
    mode: string
    onClick: (event: AdvancedAnnotation) => void
}

const AnnotationCard: React.FC<AnnotationCardProps> = ({ event, mode, onClick }: AnnotationCardProps) => {
    return event.data ? (
        <ViewAnnotation annotationColor={event.__color} onClick={() => onClick(event)}>
            <div className="color-border">
                <h1>{`${i18n('Note from')} ${event.templateName}`}</h1>
                <p>{`${i18n('From')} ${moment(event.begin).format('LLL')}${
                    event.end ? ` to ${moment(event.end).format('LLL')}` : ``
                }`}</p>
                {event.author && <p>{`${i18n('Created by')} ${event.author}`}</p>}
                <p className="details-info">{i18n('Click to see details')}</p>
                <TimeRange color={event.__color} begin={event.begin} end={event.end} mode={mode} />
            </div>
        </ViewAnnotation>
    ) : null
}

export default AnnotationCard
